import React from 'react';
import PropTypes from 'prop-types';

import Picture from '../../Util/Picture/Picture';
import '../../../../assets/icons/171217_Zeiss_Icons_Blitzlicht.svg';
import '../../../../assets/icons/171217_Zeiss_Icons_Filter.svg';
import '../../../../assets/icons/171217_Zeiss_Icons_Kamera.svg';
import '../../../../assets/icons/171217_Zeiss_Icons_Objektiv.svg';
import '../../../../assets/icons/171217_Zeiss_Icons_Stativ.svg';
// import assets
import './authorModule.scss';

const AuthorModuleView = props => (
  <div className="m-article-module m-article-module--wide m-article-module--grey">
    <div className={'m-author-module'}>
      <div className={'m-author-module__picframe'}>
        <Picture
          class={'m-author-module__image'}
          src={{
            sm: props.src['620'],
            md: props.src['400'],
            lg: props.src['400'],
            xl: props.src['310'],
            xxl: props.src['400'],
            xxxl: props.src['1020'],
            default: props.src.default,
          }}
          alt={props.alt}
          disableZoom
        />
        <div className={'m-author-module__img-desc'}>
          {props.desc}
        </div>
      </div>
      <div className={'m-author-module__textbracket'}>
        <div className={'m-author-module__smallheadline'}>The author</div>
        <div className={'m-author-module__headline'}>{props.authorName}</div>
        <div className={'m-author-module__text'} dangerouslySetInnerHTML={{ __html: props.authorText }} />
        <div className={'m-author-module__equipmentwrapper'}>
          {(() => {
            if (props.equipmentModules && props.equipmentModules.modules && props.equipmentModules.modules.length > 0) {
              return props.equipmentModules.modules.map(module => (
                <div key={module.data.equipmenttype} className={'m-author-module__equipment'}>
                  <div className={'m-author-module__hr'} />
                  <div className={'m-author-module__equipimg'}>
                    {(() => {
                      switch (module.data.equipmenttype) {
                        case 'stand':
                          return (<svg>
                            <use href="#171217_Zeiss_Icons_Stativ" />
                          </svg>);
                        case 'lens':
                          return (<svg>
                            <use href="#171217_Zeiss_Icons_Objektiv" />
                          </svg>);
                        case 'camera':
                          return (<svg>
                            <use href="#171217_Zeiss_Icons_Kamera" />
                          </svg>);
                        case 'filter':
                          return (<svg>
                            <use href="#171217_Zeiss_Icons_Filter" />
                          </svg>);
                        case 'flash':
                          return (<svg>
                            <use href="#171217_Zeiss_Icons_Blitzlicht" />
                          </svg>);
                        default:
                          return null;
                      }
                    })()}
                  </div>
                  {(() => {
                    if (module.data.linkModules && module.data.linkModules.modules) {
                      return module.data.linkModules.modules.map(linkmodule => (
                        <div key={Math.random()} className={'m-author-module__linktext'}>
                          <a href={linkmodule.data.url} target={linkmodule.data.blank ? '"_blank"' : ''} rel="noopener">
                            {linkmodule.data.label}
                          </a>
                        </div>
                      ));
                    }
                    return null;
                  })()}
                </div>
              ));
            }
            return null;
          })()}
        </div>
      </div>
    </div>
  </div>
);

AuthorModuleView.propTypes = {
  src: PropTypes.shape(),
  alt: PropTypes.string,
  desc: PropTypes.string,
  authorText: PropTypes.string,
  authorName: PropTypes.string,
  equipmentModules: PropTypes.shape({
    modules: PropTypes.arrayOf(PropTypes.shape({
      equipmenttype: PropTypes.string,
      linkModules: PropTypes.arrayOf(PropTypes.shape({
        label: PropTypes.string,
        url: PropTypes.string,
        blank: PropTypes.bool,
      })),
    })),
  }),
};

AuthorModuleView.defaultProps = {
  src: {
    sm: '',
    md: '',
    lg: '',
    xl: '',
    xxl: '',
    default: '',
  },
  alt: '',
  desc: '',
  authorText: '',
  authorName: '',
  equipmentModules: {},
};

export default AuthorModuleView;



// WEBPACK FOOTER //
// ./frontend/js/Components/Modules/AuthorModule/AuthorModuleView.jsx